Cobalt.PageRegion = function (settings) {
    this.blocks = settings.blocks;
    this.slug = settings.slug;
    this.structureID = settings.structureID;
    this.container = settings.container;
    this.inheritedBlocks = settings.inheritedBlocks;
    this.dropzone = this.container.find("div.j-dropzone");    
};

Cobalt.PageRegion.prototype =
{

    container: null,
    inheritedBlocks: null,
    blocks: [],
    structureID: null,
    slug: null,
    removeBlock: function (block) {
        block.saveDelete();
        block.element.addClass("page-block-placement-deleted");
        this.blocks.splice(this.blocks.indexOf(block), 1); // Remove it from the array        
    },
    undeleteBlock: function (block) {
        block.saveUndelete();
        block.element.removeClass("page-block-placement-deleted");
        this.blocks.push(block);
    },
    addBlock: function (element, isExisting) {
        var block = new Cobalt.PageBlock({ "region": this, "element": element, "blockID": element.attr("data-block-id"), "placementID": element.attr("data-placement-id") });
        this.blocks.push(block);
        // Place the block
        if (!isExisting) {
            this.dropzone.append(element);
            this.saveBlockPlacements(block);
        }
    },
    saveBlockPlacements: function (configureBlock) {
        for (var i = 0; i < this.blocks.length; i++) {
            var block = this.blocks[i];            
            block.savePlacement(block == configureBlock);
        }
    },
    moveBlock: function (block, newRegion) {
        this.blocks.splice(this.blocks.indexOf(block), 1); // Remove it from the array
        newRegion.blocks.push(block);
        newRegion.dropzone.append(block.element);
        block.region = newRegion;                
        this.saveBlockPlacements();
        newRegion.saveBlockPlacements();
    },
    lock: function () {
        
        var url = "/cp/page-structure/" + this.structureID + "/lock-region?regionSlug=" + this.slug;
        var that = this;

        Cobalt.Utils.getRequestVerificationToken().done(function (token) {
            $.ajax(
                {
                    url: url,
                    type: "POST",
                    data: { 'request-verification-token': token },
                    success: function (data) {
                        that.container.attr("data-locked", "true");
                        that.container.find("div.j-dropzone > div.j-page-block").remove();
                        that.dropzone.droppable("option", "disabled", true)
                        for (var i = 0; i < that.inheritedBlocks.length; i++) {
                            var inheritedElement = that.inheritedBlocks[i];
                            var element = $(inheritedElement).clone();
                            that.dropzone.append(element);
                        }
                    }
                });
        });


    },
    unlock: function () {        
        var url = "/cp/page-structure/" + this.structureID + "/unlock-region?regionSlug=" + this.slug;
        var that = this;
        Cobalt.Utils.getRequestVerificationToken().done(function (token) {
            $.ajax(
                {
                    url: url,
                    type: "POST",
                    data: { 'request-verification-token': token },
                    success: function (data) {
                        var placements = data.placements;
                        that.container.attr("data-locked", "false");
                        that.container.find("div.j-dropzone > div.j-page-block").remove();
                        that.dropzone.droppable("option", "disabled", false)
                        for (var i = 0; i < data.placements.length; i++) {

                            var blockID = data.placements[i].blockID;
                            var placementID = data.placements[i].placementID;
                            var $element = $("#page-blocks-gallery").find("div[data-block-id=" + blockID + "]");
                            if ($element != null) {
                                var element = $element.clone();
                                var block = new Cobalt.PageBlock({ "region": that, "element": element, "blockID": blockID, "placementID": placementID });
                                that.blocks.push(block);
                                that.dropzone.append(element);
                            }
                        }
                    }
                });
        });
    },
    configure: function () {
        var url = "/cp/page-structure/" + this.structureID + "/configure-region?regionSlug=" + this.slug;
        var that = this;
        $.get(url, function (data) {
            that.createConfigureModal(data.html);
        });
    },
    createConfigureModal: function (html) {

        var that = this;
        var $editDiv = $('<div>');
        $editDiv.html(html);
        $editDiv.dialog({
            modal: true,
            dialogClass: "modal category-modal",
            draggable: false,
            title: "Configure Page Region",
            resizable: false,
            close: function (event, ui) {
                $(event.target).dialog("destroy");
                $(event.target).remove();
            }
        });

        $editDiv.parent().center({ sizeToWindow: true, maxWidth: 640, maxHeight: 500, minHeight: 540 });

        $editDiv.find("form").ajaxForm(
        {
            type: "POST",
            dataType: "json",
            beforeSubmit: function () {

            },
            success: function (result) {
                $editDiv.dialog("close");
                if (!result.Success) {
                    that.createConfigureModal(result.html);
                }
                else {

                }
                return false;
            }
        });

        Cobalt.triggerHtmlInsert($editDiv);

        // find any errors
        var errorFields = $editDiv.find(".field-errors");

        if (errorFields.length > 0) {
            var $firstErrorField = $(errorFields[0]);
            var erroredTabID = $firstErrorField.parents("div.tab-content-item").attr("data-tab-id");
            var erroredTabItem = $firstErrorField.parents("form").find("ul.tabbed-tabs").find("li[data-tab-id=" + erroredTabID + "]>a");
            erroredTabItem.trigger('click');            
        }
    }

};


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.PageRegion.js